import React, { useState } from 'react'

import {
  MdClose,
  MdDashboard,
  MdLogout
} from 'react-icons/md'

import {
  FaMoneyBillWave,
  FaUser
} from 'react-icons/fa'

import {
  BsClockHistory
} from 'react-icons/bs'

import {
  RxHamburgerMenu
} from 'react-icons/rx'

import {
  NavLink,
  useNavigate
} from 'react-router-dom'

import axios from 'axios'
import { useSelector } from 'react-redux'


const navItems = [
  {
    label: 'Dashboard',
    to: '/dashboard/home',
    icon: MdDashboard
  },
  {
    label: 'Pay',
    to: '/dashboard/pay',
    icon: FaMoneyBillWave
  },
  {
    label: 'Transactions',
    to: '/dashboard/payments',
    icon: BsClockHistory
  },
  {
    label: 'Profile',
    to: '/dashboard/profile',
    icon: FaUser
  }
]


export default function Navbar() {

  const [openSideNav, setOpenSideNav] =
    useState(false)

  const navigate = useNavigate()

  const {
    url,
    currentUser
  } = useSelector(state => state)


  const fullname =
    currentUser?.fullname?.trim() || ''

  const names =
    fullname
      .split(/\s+/)
      .filter(Boolean)

  const firstName =
    names[0] || 'Tenant'

  const initials =
    names.length >= 2
      ? `${names[0][0]}${names[1][0]}`
      : names[0]?.[0] || 'R'


  const logout = async () => {

    try {

      await axios.post(
        `${url}/auth/logout`,
        {},
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                'access_token'
              )}`
          }
        }
      )

    } catch (error) {

      console.error(
        'Logout error:',
        error
      )

    } finally {

      localStorage.removeItem(
        'access_token'
      )

      setOpenSideNav(false)

      navigate(
        '/auth/signin/',
        {
          replace: true
        }
      )

    }

  }


  const navLinkClass =
    ({ isActive }) => `
      group
      flex
      items-center
      gap-3
      rounded-xl
      px-3.5
      py-3
      text-sm
      font-semibold
      transition

      ${
        isActive
          ? `
            bg-white
            text-[#101828]
            shadow-sm
          `
          : `
            text-slate-300
            hover:bg-white/10
            hover:text-white
          `
      }
    `


  const NavContent = ({
    mobile = false
  }) => (

    <>

      {/* BRAND */}

      <div className="px-1">

        <div className="
          flex
          items-center
          gap-3
        ">

          <div className="
            flex
            h-10
            w-10
            items-center
            justify-center
            rounded-xl
            bg-green-500
            text-lg
            font-black
            text-white
            shadow-sm
          ">
            R
          </div>


          <div>

            <p className="
              text-lg
              font-bold
              tracking-tight
              text-white
            ">
              RentHub
            </p>

            <p className="
              text-[11px]
              font-medium
              uppercase
              tracking-[0.2em]
              text-slate-400
            ">
              Customer Portal
            </p>

          </div>

        </div>

      </div>


      <div className="
        my-6
        h-px
        bg-white/10
      " />


      {/* LINKS */}

      <nav className="
        flex
        flex-1
        flex-col
        gap-1.5
      ">

        {navItems.map(item => {

          const Icon = item.icon

          return (

            <NavLink
              key={item.to}
              to={item.to}
              className={navLinkClass}
              onClick={() =>
                mobile &&
                setOpenSideNav(false)
              }
            >

              <Icon className="
                text-xl
                shrink-0
              " />

              <span>
                {item.label}
              </span>

            </NavLink>

          )

        })}

      </nav>


      {/* CUSTOMER */}

      <div className="
        mt-6
        border-t
        border-white/10
        pt-5
      ">

        <div className="
          flex
          items-center
          gap-3
          rounded-xl
          bg-white/5
          px-3
          py-3
        ">

          <div className="
            flex
            h-10
            w-10
            shrink-0
            items-center
            justify-center
            rounded-full
            bg-violet-600
            text-sm
            font-bold
            text-white
          ">
            {initials}
          </div>


          <div className="
            min-w-0
            flex-1
          ">

            <p className="
              text-[11px]
              text-slate-400
            ">
              Welcome back
            </p>

            <p className="
              truncate
              text-sm
              font-semibold
              text-white
            ">
              {firstName}
            </p>

          </div>

        </div>


        <button
          type="button"
          onClick={logout}
          className="
            mt-3
            flex
            w-full
            items-center
            gap-3
            rounded-xl
            px-3.5
            py-3
            text-sm
            font-semibold
            text-slate-300
            transition
            hover:bg-red-500/10
            hover:text-red-300
          "
        >

          <MdLogout className="
            text-xl
          " />

          Logout

        </button>


        <p className="
          mt-4
          px-3
          text-[11px]
          leading-5
          text-slate-500
        ">
          RentHub is a product of Rivmev Services.
        </p>

      </div>

    </>

  )


  return (

    <>

      {/* ========================
          DESKTOP SIDEBAR
      ======================== */}

      <aside className="
        fixed
        left-0
        top-0
        hidden
        h-screen
        w-[15em]
        flex-col
        bg-[#101828]
        px-5
        py-6
        font-[Satoshi]
        lg:flex
        z-40
      ">

        <NavContent />

      </aside>



      {/* ========================
          MOBILE HEADER
      ======================== */}

      <header className="
        fixed
        inset-x-0
        top-0
        z-40
        flex
        h-16
        items-center
        justify-between
        border-b
        border-gray-200
        bg-white/95
        px-5
        backdrop-blur
        lg:hidden
      ">

        <div className="
          flex
          items-center
          gap-2.5
        ">

          <div className="
            flex
            h-9
            w-9
            items-center
            justify-center
            rounded-xl
            bg-green-600
            font-black
            text-white
          ">
            R
          </div>


          <div>

            <p className="
              font-bold
              leading-4
              text-gray-900
            ">
              RentHub
            </p>

            <p className="
              text-[10px]
              uppercase
              tracking-[0.16em]
              text-gray-400
            ">
              Customer
            </p>

          </div>

        </div>


        <button
          type="button"
          onClick={() =>
            setOpenSideNav(true)
          }
          className="
            flex
            h-10
            w-10
            items-center
            justify-center
            rounded-xl
            border
            border-gray-200
            text-gray-700
          "
          aria-label="Open navigation"
        >

          <RxHamburgerMenu className="
            text-xl
          " />

        </button>

      </header>



      {/* ========================
          MOBILE DRAWER
      ======================== */}

      {openSideNav && (

        <div className="
          fixed
          inset-0
          z-50
          lg:hidden
        ">

          <button
            type="button"
            aria-label="Close navigation backdrop"
            onClick={() =>
              setOpenSideNav(false)
            }
            className="
              absolute
              inset-0
              bg-black/45
            "
          />


          <aside className="
            relative
            flex
            h-full
            w-[17rem]
            flex-col
            bg-[#101828]
            px-5
            py-6
            shadow-2xl
          ">

            <button
              type="button"
              onClick={() =>
                setOpenSideNav(false)
              }
              className="
                absolute
                right-4
                top-4
                flex
                h-9
                w-9
                items-center
                justify-center
                rounded-xl
                bg-white/10
                text-white
              "
              aria-label="Close navigation"
            >

              <MdClose className="
                text-xl
              " />

            </button>


            <NavContent mobile />

          </aside>

        </div>

      )}

    </>

  )
}